#import "./SentenceGroupDetails.graphql"
query SentenceGroupsQuery($mine: Boolean!) {
  sentenceGroups(mine: $mine) {
    ...sentenceGroupDetails
  }
}
